module.exports = __webpack_public_path__ + "static/media/favicon.2e04b4c6.ico";